import React, { useState } from "react";
import { Lock } from "lucide-react";
import { Logo, LogoLockup } from "@/components/Logo";
import { DefenseFeed } from "@/components/DefenseFeed";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const [loading, setLoading] = useState(false);

  const handleLogin = () => {
    setLoading(true);
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-navy">
      {/* Left brand panel */}
      <div className="relative hidden lg:flex flex-col items-center justify-center text-center px-14 py-16 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1761437855740-c894da924d79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGRhcmslMjBnZW9tZXRyaWMlMjBnb2xkfGVufDB8fHx8MTc4MzU1Nzc4N3ww&ixlib=rb-4.1.0&q=85"
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />

        {/* Hero logo + Command Center */}
        <div className="relative z-10 flex flex-col items-center animate-fade-up">
          <Logo variant="light" className="h-52 w-auto drop-shadow-2xl" />
          <p className="text-gold text-sm font-semibold uppercase tracking-[0.35em] mt-2">
            Command Center
          </p>
        </div>

        {/* Supporting sales copy */}
        <div className="relative z-10 mt-16 max-w-md">
          <p className="overline text-gold mb-4">Sales Command Center</p>
          <h1 className="font-display text-3xl xl:text-4xl font-bold text-white leading-tight tracking-tighter mb-5">
            Qualify. Score. Win CMMC readiness deals.
          </h1>
          <p className="text-slate-300 leading-relaxed">
            Internal command center for scoring CMMC readiness leads, recommending the right engagement tier,
            and generating next-action sales guidance.
          </p>
        </div>

        <div className="relative z-10 mt-16 text-xs text-slate-400 tracking-wide">
          Internal use only. Not public-facing.
        </div>
      </div>

      {/* Right login panel */}
      <div className="flex items-center justify-center p-8 bg-white overflow-y-auto">
        <div className="w-full max-w-sm py-8 animate-fade-up">
          <div className="lg:hidden mb-10">
            <LogoLockup variant="dark" size="md" />
          </div>
          <p className="overline text-gold-dark mb-3">Secure Access</p>
          <h2 className="font-display text-3xl font-bold text-navy tracking-tight mb-2">Sign in</h2>
          <p className="text-muted-foreground text-sm mb-8 leading-relaxed">
            Authenticate with your ComplyX Gov Google account to access the command center.
          </p>
          <button
            data-testid="google-login-button"
            onClick={handleLogin}
            disabled={loading}
            className="w-full flex items-center justify-center gap-3 rounded-md bg-navy px-5 py-3.5 text-white font-medium hover:bg-navy-700 transition-colors disabled:opacity-60"
          >
            <Lock className="h-4 w-4 text-gold" aria-hidden="true" />
            {loading ? "Redirecting…" : "Continue with Google"}
          </button>
          <p className="text-xs text-muted-foreground mt-8 leading-relaxed border-t border-border pt-6">
            ComplyX Gov provides readiness support, documentation assistance, and assessment preparation services.
            Formal CMMC certification assessments must be conducted independently by an authorized C3PAO.
          </p>

          <div className="mt-6">
            <DefenseFeed dark={false} />
          </div>
        </div>
      </div>
    </div>
  );
}
